import React, { Component } from "react";

class OfflineAutocompleteClass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: props.value ? props.value.label : "",
      open: false
    };

    this.boxRef = null;
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value && nextProps.value.label !== this.state.search) {
      this.setState({ search: nextProps.value.label });
    }
  }

  handleClickOutside = (e) => {
    if (this.boxRef && !this.boxRef.contains(e.target)) {
      this.setState({ open: false });
    }
  };

  handleChange = (e) => {
    this.setState({
      search: e.target.value,
      open: true
    });
  };

  selectValue = (item) => {
    this.setState({
      search: item.label,
      open: false
    });

    this.props.onChange(item);
  };

  render() {
    const { options = [], placeholder = "Search..." } = this.props;
    const { search, open } = this.state;

    const filtered = options.filter((o) =>
      o.label.toLowerCase().includes(search.toLowerCase())
    );

    return (
      <div
        ref={(r) => (this.boxRef = r)}
        style={{ position: "relative", width: "100%" }}
      >
        <input
          type="text"
          placeholder={placeholder}
          value={search}
          disabled={this.props.disabled} 
          onFocus={() => this.setState({ open: true })}
          onChange={this.handleChange}
          style={{
            width: "100%",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "4px"
          }}
        />

        {open && !this.props.disabled && (
          <div
            style={{
              position: "absolute",
              top: "40px",
              width: "100%",
              maxHeight: "250px",
              overflowY: "auto",
              background: "#fff",
              border: "1px solid #ddd",
              borderRadius: "4px",
              zIndex: 50
            }}
          >
            {filtered.length === 0 && (
              <div style={{ padding: "8px", color: "#777" }}>
                No results found
              </div>
            )}

            {filtered.map((item) => (
              <div
                key={item.value}
                onClick={() => this.selectValue(item)}
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  borderBottom: "1px solid #f1f1f1"
                }}
              >
                {item.label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default OfflineAutocompleteClass;
